import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, ref } from 'vue';
import Sidebar from '@/modules/Chat/components/Sidebar.vue';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import ProjectRepository from '@/repositories/ProjectRepository';
import Project from '@/models/Project';
import ChatContent from '@/modules/Chat/components/ChatContent.vue';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatView',
  setup(__props) {

const selectedProject = ref<Project | null>(null);

const selectedProjectId = computed(() => {
    if (selectedProject.value == null) {
        return null;
    }

    return selectedProject.value.projectId;
});

function selectProject(projectId: string) {
    selectedProject.value = ProjectRepository.getProjectById(projectId);
}

EventBus.$on(EventBusEvents.openChatProject, selectProject);
EventBus.$on(EventBusEvents.updateProject, selectProject);

(async () => {
    if (router.currentRoute.params.id != null) {
        const response = await Project.getById(router.currentRoute.params.id);
        if (response != null) {
            selectProject(router.currentRoute.params.id);
        } else {
            router.replace(`/chat`);
        }
    }
})();

onBeforeUnmount(() => {
    EventBus.$off(EventBusEvents.openChatProject, selectProject);
    EventBus.$off(EventBusEvents.updateProject, selectProject);
});

return { __sfc: true,selectedProject, selectedProjectId, selectProject, Sidebar, ChatContent }
}

})